import {resumePlay} from "./ios-safari";

const MODE_PIP = "picture-in-picture";

export function isPipSupported(video?: HTMLVideoElement): boolean {
    return Boolean(video?.requestPictureInPicture || video?.webkitSupportsPresentationMode?.(MODE_PIP));
}

export async function requestPip(video?: HTMLVideoElement): Promise<PictureInPictureWindow | void> {
    try {
        if (video?.requestPictureInPicture) {
            if (video.webkitSupportsPresentationMode !== undefined) {
                $(video).one("leavepictureinpicture", () => resumePlay(video));
            }

            return await video.requestPictureInPicture();
        }

        if (video?.webkitSetPresentationMode) {
            if (video.webkitSupportsPresentationMode !== undefined) {
                $(video).one("leavepictureinpicture", () => resumePlay(video));
            }

            return video.webkitSetPresentationMode(MODE_PIP);
        }
    } catch (e) {
        console.error(e);
    }
}
